<template>
  <div class="modal-overlay modal-terms-overlay">
    <div class="close" :style="{ 'border-color': primaryColor ? primaryColor : '#CCC' }">
      <div class="container-text">
        <div
          v-html="displayTermHtml"
          class="html-wrapper"
          :style="template.secondaryTheme ? { color: primaryColor } : { color: 'black' }"
        ></div>
      </div>
      <div class="div-button">
        <button
          @click="$emit('close-modal')"
          class="button-terms"
          :style="{ background: btnColor, color: btnTextColor }"
        >
          {{ $t('common.understood') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/store.js'
import { mapState } from 'vuex'
import { loginFB } from '../services/ServFB.js'
import { stripInlineFontSizeFromTags } from '../helpers/sanitizeTermHtml.js'
const lFB = new loginFB()
export default {
  name: 'ModalTerms',
  components: {},
  props: {
    termHtml: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    terms: '',
  }),
  methods: {
    getTerms() {
      if (!this.domain || !this.subdomain) return
      lFB
        .getFileContentLoc(this.domain, this.subdomain)
        .then(res => {
          if (res) {
            this.terms = res
          }
        })
        .catch(err => alert(err))
    },
  },
  watch: {
    domain(newValue) {
      if (newValue) this.getTerms()
    },
    subdomain(newValue) {
      if (newValue) this.getTerms()
    },
  },
  mounted() {
    this.getTerms()
  },
  computed: {
    ...mapState(['domain', 'subdomain', 'template']),
    primaryColor() {
      return store.state.template.primaryColor
    },
    secondaryColor() {
      return store.state.template.secondaryColor
    },
    btnColor() {
      return store.state.template.primaryBtn.bgColor
    },
    btnTextColor() {
      return store.state.template.primaryBtn.textColor
    },
    displayTermHtml() {
      return stripInlineFontSizeFromTags(this.termHtml, ['h1', 'h2', 'h3', 'h4'])
    },
  },
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000000aa;
  z-index: 1000;
}

.close {
  width: 340px;
  height: 480px;
  cursor: pointer;
  background-color: #fff;
  opacity: 1;
  border-radius: 7px;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.close:hover {
  opacity: 1 !important;
  cursor: context-menu !important;
}

.close-modal {
  color: white;
  font-size: 1.3rem !important;
  margin-left: 10px;
  margin-top: 7px;
  text-align: right;
  margin-right: 49px;
  top: 12px;
  position: relative;
}

.close-modal:hover {
  font-size: 1.4rem !important;
  cursor: pointer;
}

.html-wrapper {
  font-family: Inter, sans-serif;
  font-weight: 400;
  width: 285px;
  margin: 8px 24px;
  text-align: center;
}

.html-wrapper ::v-deep *,
.html-wrapper ::v-deep *::before,
.html-wrapper ::v-deep *::after {
  font-family: Inter, sans-serif !important;
}

.container-text {
  height: 390px;
  margin-top: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

.button-terms {
  width: 210px;
  height: 43px;
  font-family: Inter, sans-serif;
  font-size: 1rem;
  margin-top: 13px;
  border-radius: 4px;
  font-weight: 600;
  border: none;
  text-transform: none;
}

.button-terms:hover {
  transition: 0.3s;
  position: relative;
  opacity: 1;
}

.div-button {
  width: 400px;
  align-items: center;
  justify-content: center;
  display: flex;
}

@media screen and (min-width: 470px) {
  .close {
    width: 435px;
    height: 580px;
  }

  .close-modal {
    color: white;
    font-size: 1.3rem !important;
    margin-left: 10px;
    margin-top: 7px;
    text-align: right;
    margin-right: 49px;
    top: 12px;
    position: relative;
  }

  .close-modal:hover {
    font-size: 1.4rem !important;
    cursor: pointer;
  }

  .html-wrapper {
    font-weight: 400;
    width: 365px;
    text-align: justify;
  }

  .container-text {
    height: 490px;
    margin-top: 20px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

@media screen and (min-width: 767px) {
  .modal-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000000aa;
    z-index: 1000;
  }

  .close {
    width: 500px;
    height: 550px;
  }

  .close:hover {
    opacity: 1 !important;
    cursor: context-menu !important;
  }

  .close-modal {
    color: white;
    font-size: 1.3rem !important;
    margin-left: 10px;
    margin-top: 7px;
    text-align: right;
    margin-right: 49px;
    top: 12px;
    position: relative;
  }

  .close-modal:hover {
    font-size: 1.4rem !important;
    cursor: pointer;
  }

  .html-wrapper {
    color: white;
    font-weight: 400;
    width: 410px;
    text-align: justify;
  }

  .container-text {
    height: 460px;
    margin-top: 20px;
    overflow-y: auto;
  }

  .button-terms {
    width: 210px;
    height: 43px;
    font-size: 1rem;
    margin-top: 13px;
    border-radius: 4px;
    font-weight: 600;
  }
}
</style>

<!-- Unscoped: must beat global #app heading rules from _typography.scss -->
<style lang="scss">
#app .modal-terms-overlay .html-wrapper h1,
#app .modal-terms-overlay .html-wrapper h2,
#app .modal-terms-overlay .html-wrapper h3,
#app .modal-terms-overlay .html-wrapper h4 {
  font-family: Inter, sans-serif !important;
  font-size: 1.4rem !important;
  line-height: 1.35 !important;
  letter-spacing: normal !important;
}

.modal-terms-overlay .container-text {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.22) transparent;
}

.modal-terms-overlay .container-text::-webkit-scrollbar {
  width: 4px;
}

.modal-terms-overlay .container-text::-webkit-scrollbar-track {
  background: transparent;
}

.modal-terms-overlay .container-text::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.22);
  border-radius: 999px;
}

.modal-terms-overlay .container-text::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.38);
}
</style>
